/**
 * 项目报表
 */
import React from 'react';
import './projectReport.less';
import { Tabs } from "antd";
import MonthReport from "./monthReport/monthReport";
import {
    getReportTypes
} from "../../../../services/project/ProjectService";
import GroupReportTable from './group-report'

const { TabPane } = Tabs;
let _this;

class ProjectReport extends React.Component {

    constructor(props) {
        super(props);
        //  创建ref容器
        _this = this;
        _this.state = {
            meet: 0,
            selectTabPane: 0, // 默认项目月报
            reportTypeList: [], // 报表类型
        }
    }

    componentDidMount() {
        this.getReportTypes();
    }

    /**
     * 
     * @param {*} 报表类型
     */
    getReportTypes = () => {
        getReportTypes({ projectId: this.props.projectId }).then(res => {
            this.setState({
                reportTypeList: [...res]
            })
        })
    }


    /**
     * 选择月报、季报、结项报告
     */
    onTabClick = (index) => {
        this.setState({
            meet: this.state.meet + 1,
            selectTabPane: Number(index)
        })
    }

    render() {
        let { selectTabPane, reportTypeList } = this.state;
        let { projectId, location } = this.props;

        const projectCode = location.state.code;

        //  不展示季报，前端处理
        let showReportTypeList = [];
        reportTypeList.map((item, index) => {
            if (item.key != 3) {
                showReportTypeList.push(item)
            }
        })

        return (
            <div className={'projectReport'}>
                <div className='tabsTitle'>
                    <Tabs destroyInactiveTabPane={true} defaultActiveKey="0" tabPosition='top' onTabClick={this.onTabClick}>
                        {showReportTypeList.map((i, index) => {
                            if ([8, 9, 10, 11, 12].includes(i.key)) {
                                return (
                                    <TabPane tab={i.text} key={i.key}>
                                        {/* 1 入组数据报表 2 失访数据报表 3 数据缺失&质疑报表 4 结算报表 5 访视进度报表 */}
                                        <GroupReportTable type={[0,0,0,0,0,0,0,0,1,2,3,4,5][i.key]} projectCode={projectCode}/>
                                    </TabPane>
                                )
                            }
                            return (
                                // TabPane 会多次共用同一个组件，会导致切换后A、B组价数据重复的问题
                                <TabPane tab={i.text} key={index} >
                                    {selectTabPane === (index) &&
                                        <MonthReport
                                            projectId={projectId}
                                            {...this.props}
                                            type={i.key}
                                        />
                                    }
                                </TabPane>
                            )
                        })}
                    </Tabs>
                </div>
            </div>
        );
    }
}

export default ProjectReport;